import { render, staticRenderFns } from "./AcessarAtaInformacoesView.vue?vue&type=template&id=3b35ed34"
import script from "./AcessarAtaInformacoesView.vue?vue&type=script&lang=js"
export * from "./AcessarAtaInformacoesView.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaInformacoesView.vue?vue&type=style&index=0&id=3b35ed34&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports